import { render, staticRenderFns } from "./EarlyFraudMail.vue?vue&type=template&id=cadc2dae&lang=pug"
import script from "./EarlyFraudMail.vue?vue&type=script&lang=js"
export * from "./EarlyFraudMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports